import axiosInstance from '../config/axios.js';

const plDeskService = {
  getDesk: async (reportDate) => {
    const response = await axiosInstance.get('/pl-desk', {
      params: { report_date: reportDate },
    });
    return response.data;
  },

  saveCosts: async (payload) => {
    const response = await axiosInstance.post('/pl-desk/costs', payload);
    return response.data;
  },
};

export default plDeskService;
